import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import {DefaultBigNumberStats} from './DefaultBigNumberStats'

export type BigNumberStatsProps = SliceComponentProps<Content.BigNumberStatsSlice>

const BigNumberStats = ({slice}: BigNumberStatsProps): JSX.Element | null => {
  switch (slice.variation) {
    case 'default':
      return <DefaultBigNumberStats slice={slice} />
    default:
      return null
  }
}

export default BigNumberStats
